import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag'
import Channels from '../components/Channels';
import Teams from '../components/Teams';
import _ from 'lodash';
import decode from 'jwt-decode';
import { render } from '@testing-library/react';

import AddChannelModal from '../components/AddChannelModal';
import InviteModal from '../components/InviteModal';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
    }

    state={
        openAddChannelModal: false,
        openInviteModal:false,
    };
    handleAddChannelClick=()=>{
        this.setState({openAddChannelModal:true});
    };
    handleCloseAddChannelModal=()=>{
        this.setState({openAddChannelModal:false});
    };
    handleInviteClick=()=>{
        this.setState({openInviteModal:true});
    };
    handleCloseInviteModal=()=>{
        this.setState({openInviteModal:false});
    };
    render(){
        const {teams,team, username} = this.props;
        
        return [<Teams key="team-sidebar" teams={teams}/>,
            <Channels
                key="channel-sidebar"
                teamName={team.name}
                userName={username}
                teamId={team.id}
                isOwner={team.admin}
                channels={team.channels}
                users={[{ id: 1, name: 'admin' }, { id: 2, name: 'playIN Bot' }]}
                onAddChannelClick={this.handleAddChannelClick}
                onInviteClick={this.handleInviteClick}
            />,
            <AddChannelModal teamId={team.id} open={this.state.openAddChannelModal} onClose={this.handleCloseAddChannelModal} key="add-channel-modal"/>,
            <InviteModal teamId={team.id} 
                open={this.state.openInviteModal} 
                onClose={this.handleCloseInviteModal} 
                key="invite-modal"/>
        
        ];
    }
};

const allTeamsQuery=gql`
  {
      me{
          id
          username
          teams{
              id
              name
              admin
              channels{
                  id
                  name
              }
          }
      }
  }
  `;

export default Sidebar;